<header class="flex flex-col gap-4 mb-6">
  @if (breadcrumbs().length > 0) {
    <nav class="flex items-center gap-1.5 text-sm text-[var(--muted)]" aria-label="Breadcrumb">
      @for (item of breadcrumbs(); track item.label; let last = $last) {
        @if (item.routerLink && item.routerLink.length) {
          <a
            [routerLink]="item.routerLink"
            [queryParams]="item.queryParams"
            class="hover:text-[var(--text)] transition-colors truncate max-w-[140px] sm:max-w-[200px]"
          >
            {{ item.label }}
          </a>
        } @else {
          <span class="truncate max-w-[140px] sm:max-w-[200px]">{{ item.label }}</span>
        }
        @if (!last) {
          <lucide-icon name="chevron-right" class="h-4 w-4 shrink-0 text-[var(--faint)]"></lucide-icon>
        }
      }
    </nav>
  }

  <div class="flex items-start justify-between gap-4 min-w-0">
    <div class="min-w-0 flex-1">
      <div class="flex items-center gap-2 min-w-0">
        <ng-content select="[headerTitlePrefix]"></ng-content>
        <h1
          class="font-semibold tracking-tight text-[var(--text)] truncate"
          [class.text-[20px]]="!titleLarge()"
          [class.text-2xl]="titleLarge()"
        >
          {{ title() }}
        </h1>
        <ng-content select="[headerTitleSuffix]"></ng-content>
      </div>
      @if (subtitle()) {
        <p class="mt-0.5 text-sm text-[var(--muted)]">{{ subtitle() }}</p>
      }
    </div>
    <div class="shrink-0 flex items-center gap-2 flex-wrap justify-end">
      <ng-content select="[headerActions]"></ng-content>
    </div>
  </div>
</header>
